// extracted by mini-css-extract-plugin
export default {"root":"Spt9LS","heading":"P6aUkz","searchFadeIn":"da_e00"};